/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Search, Filter, Download, ReportMoney, ArrowUpRight, ArrowDownRight,
} from 'tabler-icons-react';
import {
  TextInput, Tooltip, useMantineColorScheme, Progress,
} from '@mantine/core';
import { Card, ConfigProvider } from 'antd';
import { assetPrefix, renderNumber } from '../../../utilities/general';
import CustomSelect from '../../Listing/companyData/Select';
import styles from './PositionsTabV2.module.css';

export default function WalletTabV2(props) {
  const [searchValue, setSearchValue] = useState('');
  const { colorScheme } = useMantineColorScheme();

  const [selectOptions, setSelectOptions] = useState('All Assets');

  const data = [
    { value: 'All Assets', label: 'All Assets' },
    { value: 'Spot Only', label: 'Spot Only' },
    { value: 'Margin Only', label: 'Margin Only' },
    { value: 'Hide Zero Balances', label: 'Hide Zero Balances' },
  ];

  const walletData = [
    {
      asset: 'BTC',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      tradingProductType: 'Bitcoin',
      quantity: 2.4068,
      currentPrice: 43250.50,
      totalValue: 105067.89,
      dollarCostAverage: 41200.00,
      allocation: 42.5,
      type: 'Spot',
      location: 'Binance',
    },
    {
      asset: 'ETH',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      tradingProductType: 'Ethereum',
      quantity: 15.8764,
      currentPrice: 2456.78,
      totalValue: 39012.45,
      dollarCostAverage: 2200.00,
      allocation: 15.8,
      type: 'Spot',
      location: 'Coinbase',
    },
    {
      asset: 'USDC',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      tradingProductType: 'USD Coin',
      quantity: 25468.89,
      currentPrice: 1.00,
      totalValue: 25450.00,
      dollarCostAverage: 1.00,
      allocation: 10.3,
      type: 'Spot',
      location: 'Kraken',
    },
    {
      asset: 'SOL',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      tradingProductType: 'Solana',
      quantity: 234.5679,
      currentPrice: 98.45,
      totalValue: 23089.67,
      dollarCostAverage: 95.20,
      allocation: 9.3,
      type: 'Margin',
      location: 'Binance',
    },
    {
      asset: 'ADA',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      tradingProductType: 'Cardano',
      quantity: 8450.3200,
      currentPrice: 0.45,
      totalValue: 3802.64,
      dollarCostAverage: 0.52,
      allocation: 1.54,
      type: 'Spot',
      location: 'Kraken',
    },
    {
      asset: 'DOT',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      tradingProductType: 'Polkadot',
      quantity: 567.8900,
      currentPrice: 6.78,
      totalValue: 3850.30,
      dollarCostAverage: 7.25,
      allocation: 1.56,
      type: 'Spot',
      location: 'Coinbase',
    },
  ];
  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            bodyPadding: 16,
            borderRadiusLG: 14,
          },
        },
      }}
    >
      <div>
        <div className="flex flex-col gap-6 mx-auto">
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold text-[#101828] dark:text-white">Wallet</h1>
            <p className="text-base font-normal text-[#4A5565] dark:text-[#898989]">Manage your cryptocurrency holdings and portfolio</p>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Assets</div>
              <div className="text-2xl font-bold text-[#101828] dark:text-[#BEB9B9]">
                6
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Total Value</div>
              <div className="text-2xl font-bold text-[#101828] dark:text-[#BEB9B9]">
                {renderNumber(200272.95, true) || '0.00'}
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Unrealized P&L</div>
              <div className="text-2xl font-bold text-[#009966]">
                {renderNumber(9874, true) || '0.00'}
              </div>
            </Card>
          </div>
          <div className="flex flex-col items-start gap-[46px] rounded-[14px] bg-white dark:bg-[#26282C] p-6 shadow-md flex-shrink-0 self-stretch">
            <div className="w-full flex justify-between items-center">
              <div className="h-9 flex justify-center items-start gap-4">
                <TextInput
                  classNames={{
                    input: 'bg-[#FAFAFA] dark:bg-[#1a1b1e] dark:border-neutral-600 border-[#E5E7EB]',
                  }}
                  className="w-80"
                  placeholder="Search assets..."
                  radius="md"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.currentTarget.value)}
                  icon={<Search size={16} color="#99A1AF" />}
                />
                <CustomSelect
                  options={data}
                  value={selectOptions}
                  onChange={setSelectOptions}
                  icon={<Filter size={16} color="#717182" />}
                />
              </div>
              <div className={`${styles.padding} border border-[#0000001A] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-lg`}>
                <Download size={16} color={colorScheme === 'dark' ? '#898989' : '#0A0A0A'} />
                <span className="text-sm font-medium text-[#0A0A0A] dark:text-[#898989]">Export</span>
              </div>
            </div>
            <div className={`${styles.grid} w-full h-full flex flex-col items-start border border-[#F3F4F6] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-[10px]`}>
              <div className={`w-full h-10 grid items-center p-2 rounded-t-lg border-b border-[#0000001A] bg-[#F9FAFB80] dark:border-neutral-600 dark:bg-[#1a1b1e] ${styles.WalletTabHeadingGrid}`}>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Asset
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Quantity
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Current Price
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Total Value
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Dollar Cost Average
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Allocation
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Type
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Location
                </div>
              </div>
              {walletData.map((items) => (
                <div className={`w-full h-[73px] grid items-center p-2 rounded-t-lg border-b border-[#0000001A] dark:border-neutral-600 last:border-none ${styles.WalletTabRowGrid}`}>
                  <div className="flex items-center gap-3 text-base font-normal">
                    {items?.icon
                      ? (
                        <img
                          className="w-8 h-8 rounded-full"
                          src={items?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                          alt="Crypto"
                        />
                      )
                      : <ReportMoney className="w-11 h-11" />}

                    <div className="flex flex-col gap-1">
                      <span
                        className={`${styles.title} font-semibold text-[#101828] dark:text-[#898989]`}
                      >
                        {items?.asset?.length > 8 ? `${items?.asset?.slice(0, 8)}...` : items?.asset.toUpperCase() || '-'}
                      </span>
                      <span
                        className={`${styles.subTitle}`}
                      >
                        {items?.tradingProductType}
                      </span>
                    </div>
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {renderNumber(items?.quantity)}
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {renderNumber(items?.currentPrice, true)}
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {renderNumber(items?.totalValue, true)}
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {renderNumber(items?.dollarCostAverage, true)}
                  </div>
                  <div className={`${styles.title} flex flex-col gap-2 font-medium text-[#101828] dark:text-[#898989]`}>
                    <span>{`${renderNumber(items.allocation)}%`}</span>
                    <Progress
                      value={items.allocation}
                      radius="md"
                      color="#0861C7"
                      style={{ width: 120 }}
                      sx={{ backgroundColor: '#F3F4F6' }}
                    />
                  </div>
                  <div className={`text-xs w-fit font-medium rounded-lg py-1 px-2 border ${items.type === 'Spot' ? 'bg-[#EFF6FF] text-[#0861C7] border-[#BEDBFF]' : 'bg-[#FFF7ED] text-[#F54900] border-[#FFD6A7]'}`}>
                    {items?.type}
                  </div>
                  <div className="w-fit py-1 px-2 text-xs bg-[#F9FAFB] rounded-lg border border-[#0000001A] font-medium text-[#0A0A0A]">
                    {items.location}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}
